import { render } from "./livestreamPlayer.vue?vue&type=template&id=746967a8"
import script from "./livestreamPlayer.vue?vue&type=script&lang=js"
export * from "./livestreamPlayer.vue?vue&type=script&lang=js"

import "./livestreamPlayer.vue?vue&type=style&index=0&id=746967a8&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__